import { useState } from "react";
import {
  Button,
  Datagrid,
  FunctionField,
  InfiniteList,
  Labeled,
  RichTextField,
  useDataProvider,
  useRefresh,
  Confirm,
  useRecordContext,
} from "react-admin";
import { Card, CardContent, MenuItem, Select, Input } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { dryRunOptions } from "../../utils";

const ReverseMatchDateAndParamsField = (props) => {
  const record = useRecordContext();
  return (
    <>
      <FunctionField
        {...props}
        sx={{ fontWeight: "bold", color: record?.error ? "red" : "black" }}
        render={(value) =>
          value["created"] ? `${new Date(+value["created"]).toString()}` : "-"
        }
      />
      <FunctionField
        {...props}
        sx={{ fontWeight: "bold", color: record?.error ? "red" : "black" }}
        render={(value) =>
          value["dryrun"] !== undefined
            ? `, Emails sent: ${!value["dryrun"]}`
            : ""
        }
      />
      <FunctionField
        {...props}
        sx={{ fontWeight: "bold", color: record?.error ? "red" : "black" }}
        render={(value) =>
          value["pastDays"] ? `, Past Days: ${value["pastDays"]}` : ""
        }
      />
    </>
  );
};

const ReverseMatchList = (props) => {
  const [dryRun, setDryRun] = useState(true);
  const [pastDays, setPastDays] = useState(7);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const dataProvider = useDataProvider();
  const refresh = useRefresh();

  const { mutateAsync } = useMutation({
    mutationFn: dataProvider.runReverseMatch,
  });

  const runReverseMatch = async () => {
    await mutateAsync({ pastDays, dryRun });
    await refresh();
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    await runReverseMatch();
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  return (
    <>
      <Card sx={{ display: "block", margin: "16px 0 16px 0" }}>
        <CardContent>
          <Labeled label="Run Reverse Match" sx={{ margin: "0 16px 0" }}>
            <Button
              label="Run"
              sx={{ width: "210px", height: "30px" }}
              variant="contained"
              onClick={() => setConfirmOpen(true)}
            />
          </Labeled>

          <Labeled label="Select" sx={{ margin: "0 16px 0" }}>
            <Select
              variant="outlined"
              style={{ width: "210px", height: "30px" }}
              onChange={(event) => setDryRun(event.target.value)}
              value={dryRun}
            >
              {dryRunOptions?.map((option) => (
                <MenuItem key={`dryrun-${option.id}`} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </Labeled>

          <Labeled
            label="Select Active Providers for Past Days"
            sx={{ margin: "0 16px 0" }}
          >
            <Input
              variant="standard"
              type="number"
              style={{ width: "210px", height: "30px" }}
              onChange={(event) => setPastDays(event.target.value)}
              value={pastDays}
            />
          </Labeled>
        </CardContent>
      </Card>

      <Confirm
        isOpen={confirmOpen}
        title="Run Reverse Match"
        content={`Are you sure you want run with params: Past Days: ${pastDays}, Dry Run: ${dryRun}?`}
        onConfirm={handleConfirm}
        onClose={handleConfirmClose}
      />

      <InfiniteList
        {...props}
        storeKey="all-reverse-matches-list"
        perPage={100}
        filters={null}
        filterDefaultValues={null}
        sort={{ field: "created", order: "DESC" }}
        exporter={null}
        actions={null}
        disableSyncWithLocation={true}
      >
        <Datagrid bulkActionButtons={null}>
          <Card>
            <CardContent>
              <Labeled
                label="Run date"
                sx={{ display: "block", margin: "16px" }}
              >
                <ReverseMatchDateAndParamsField />
              </Labeled>

              <Labeled
                label="Providers"
                sx={{ display: "block", margin: "16px" }}
              >
                <RichTextField
                  source="providers"
                  sx={{ width: "100%", overflowY: "auto", maxHeight: "100px" }}
                />
              </Labeled>

              <Labeled
                label="Match Count"
                sx={{ display: "block", margin: "16px" }}
              >
                <RichTextField
                  source="matchCount"
                  sx={{ width: "100%", overflowY: "auto", maxHeight: "200px" }}
                />
              </Labeled>

              <Labeled label="Debug" sx={{ display: "block", margin: "16px" }}>
                <RichTextField
                  source="debug"
                  sx={{ width: "100%", overflowY: "auto", maxHeight: "200px" }}
                />
              </Labeled>
            </CardContent>
          </Card>
        </Datagrid>
      </InfiniteList>
    </>
  );
};

export default ReverseMatchList;
